<template>
<div>
    <h4>{{label}}</h4>
    <b-row>
        <!-- <b-col>
            <b-row v-if="hasMapping" class="le-headers">
                <b-col v-for="(mappingData,key) in dataMappings" :key="`${paramKey}-listinput-mapping-${key}`"><h5>{{mappingData[1]}}</h5></b-col>
            </b-row>
        </b-col> -->
        <b-row class="le-input-row" v-for="(value,index) in listData" :key="`${paramKey}-listinput-${index}`">
            <template v-if="hasMapping">
                <b-col v-for="(mappingData,key) in dataMappings" :key="`${paramKey}-listinput-mapping-${key}-input`">
                    <h5>{{mappingData[1]}}</h5>
                    <base-input v-if="mappingData[0]!=='checkbox'" v-model="listData[index][key]" :type="mappingData[0]" />
                    <base-checkbox v-else v-model="listData[index][key]" />
                </b-col>
            </template>
            <b-col v-else>
                <base-input v-model="listData[index]" @input="listChanged()" />
            </b-col>
            <b-col>
                <base-button icon type="danger" @click="deleteFromList(index)">
                    <span class="btn-inner--icon">
                        <i class="ni ni-fat-remove" style="font-size:15px" />
                    </span>
                </base-button>
            </b-col>
        </b-row>
        <base-button icon type="info" @click="addToList()">
            <span class="btn-inner--icon">
                <i class="ni ni-fat-add"/>
            </span>
        </base-button>
    </b-row>
</div>

</template>

<script>
export default {
    name:'list-editor',
    props:{
        paramKey:String,
        data:Array,
        dataMappings:Object,
        label:String,
    },
    data(){
        return {
            types:{
                'text':String,
                'number':Number,
                'checkbox':Boolean,
            },

            hasMapping:false,
            listData:[],
        }
    },
    created(){
        this.hasMapping=(this.dataMappings!==null && this.dataMappings!==undefined);
        for(var i in this.data){
            if(this.hasMapping){
                for(var valueKey in this.dataMappings){
                    var valueType=this.types[this.dataMappings[valueKey][0]];
                    this.data[i][valueKey]=valueType(this.data[i][valueKey]);
                }
            }
            this.listData.push(this.data[i]);
        }
    },
    watch:{
        listData:{
            handler(oldVal,newVal){
                this.listChanged();
            },
            deep:true,
        }
    },
    methods:{
        deleteFromList(index){
            this.listData.splice(index,1);
            this.listChanged();
            this.$forceUpdate();
        },
        addToList(){
            if(this.hasMapping){
                var newLine={};
                for(var i in this.dataMappings){
                    newLine[i]=this.types[this.dataMappings[i][0]]('');
                }
                this.listData.push(newLine);
            }
            else {
                this.listData.push('');
            }
            this.listChanged();
            this.$forceUpdate();
        },
        listChanged(){
            this.$emit('change',[this.listData,this.paramKey]);
        }
    }
}
</script>

<style>
.le-input-row button {
    max-height: 43px;
}
/* 
.le-input-row input {
    min-width: 130px;
} */

</style>